import axios from 'axios';
import { LlavesEndPointServicios } from "../Configuracion/Llaves/RepositorioConfig";

const InstanciaPublica = axios.create();
InstanciaPublica.defaults.baseURL = LlavesEndPointServicios.UrlServicioParametros;

InstanciaPublica.CancelToken = axios.CancelToken;
InstanciaPublica.isCancel = axios.isCancel;

//objeto que representa las peticiones genericas que se hagan al [Api CORE] del set 
const requestGenericoPublico = {
    get: (url) => InstanciaPublica.get(url),
    post: (url, body) => InstanciaPublica.post(url, body),
    put: (url, body) => InstanciaPublica.put(url, body),
    delete: (url) => InstanciaPublica.delete(url)
};

export default requestGenericoPublico;